import md5 from 'md5'

export const getBaseInfo = {
	Cookie: {
		write: function (name, value, exp, path, domain, secure) {
			if (!/^\w*$/.test(name)) {
				alert("cookie格式不正确");
			}
			if (/; /.test(value)) {
				alert("cookie格式不正确");
			}
			var cookieValue = name + "=" + value;
			if (exp) {
				var dt = new Date();
				dt.setTime(dt.getTime() + (exp * 1000));
				cookieValue += "; expires=" + dt.toGMTString();
			}
			if (path) {
				cookieValue += "; path=" + path;
			}
			if (domain) {
				cookieValue += "; domain=" + domain;
			}
			if (secure) {
				cookieValue += "; secure";
			}
			document.cookie = cookieValue;

		},
		rewriteKey: function (name, key, keyVal, exp, path, domain, secure) {
			var str = key;
			if (keyVal) {
				var cookie = this.read(name);
				var reg = new RegExp("\\b" + key + "=([^&]*)\\b", "g");
				str = cookie.replace(reg,
					function (m1, m2) {
						return m1.replace(m2, keyVal);
					})
			}
			if (/^\d+(s|m|h|d)$/i.test(exp)) {
				if (/^\d+s$/i.test(exp)) {
					this.setSec(name, str, (exp.replace(/s$/i, "")), path, domain, secure);
				}
				if (/^\d+m$/i.test(exp)) {
					this.setMin(name, str, (exp.replace(/m$/i, "")), path, domain, secure);
				}
				if (/^\d+h$/i.test(exp)) {
					this.setHour(name, str, (exp.replace(/h$/i, "")), path, domain, secure);
				}
				if (/^\d+d$/i.test(exp)) {
					this.setDay(name, str, (exp.replace(/d$/i, "")), path, domain, secure);
				}
			} else {
				this.write(name, str, exp, path, domain, secure);
			}
		},
		setDay: function (name, value, exp, path, domain, secure) {
			this.write(name, value, (exp * 24 * 60 * 60), path, domain, secure);
		},
		setHour: function (name, value, exp, path, domain, secure) {
			this.write(name, value, (exp * 60 * 60), path, domain, secure);
		},
		setMin: function (name, value, exp, path, domain, secure) {
			this.write(name, value, (exp * 60), path, domain, secure);
		},
		setSec: function (name, value, exp, path, domain, secure) {
			this.write(name, value, (exp), path, domain, secure);
		},
		read: function (name, key, isJSON) {
			var cookieValue = "";
			var arrStr = document.cookie.split("; ");
			for (var i = 0; i < arrStr.length; i++) {
				var temp = arrStr[i].match(/^(\w+)=(.+)$/);
				if (temp && temp.length > 1 && temp[1] == name) {
					cookieValue = temp[2];
					break;
				}
			}
			if (cookieValue == "") {
				return null;
			} else {
				if (key) {
					if (!isJSON) {
						return new getBaseInfo.Param().parse(cookieValue)[key];
					} else {
						return JSON.parse(cookieValue)[key];
					}
				}
				return cookieValue;
			}
		},
		remove: function (name, path, domain) {
			var cookie = name + "=";
			if (path) {
				cookie += '; path=' + path;
			}
			if (domain) {
				cookie += ';domain=' + domain;
			}
			cookie += '; expires=Fri, 02-Jan-1970 00:00:00 GMT';
			document.cookie = cookie;
		},
	},
	Md5: function (str) {
		return md5(str)
	},
	Param: function () {
		var arr = [];
		var o = {};
		this.parse = function (str) {
			var a = str.split("&");
			for (var i = 0,
				l = a.length; i < l; i++) {
				var k = a[i].split("=");
				o[k[0]] = k[1];
			}
			return o;
		};
		this.toString = function (filter) {
			filter = filter || "&";
			return arr.join(filter);
		};
		this.add = function (key, val) {
			var prm = key + "=" + val;
			arr.push(prm);
			return this;
		}
	},

	// 判断是否为空
	IsEmpty: function (obj) {
		if (typeof obj != 'undefined' && obj != null && obj != "") {
			return false;
		} else {
			return true;
		}
	},

	Guid: function () {
		function S4() {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		}
		return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
	},

    /**
	 * 获取 mid，如果 cookie 不存在 mid，收到调用生成 mid 的方法，写入 cookie
	 */
	getKgMid: function () {
		var mid = getBaseInfo.Cookie.read("kg_mid");

		if (navigator.cookieEnabled) {
			// 没有禁用 cookie
			if (getBaseInfo.IsEmpty(mid)) {
				var n = getBaseInfo.Guid();
				mid = getBaseInfo.Md5(n);
				try {
					// 写 cookie，注入 kg_mid
					getBaseInfo.Cookie.write("kg_mid", getBaseInfo.Md5(n), 10000 * 86400, "/", "kugou.com");
					getBaseInfo.Cookie.write("kg_mid", getBaseInfo.Md5(n), 10000 * 86400, "/", location.host);
				} catch (error) { }
			}
		} else {
			// 禁用 cookie
			// 前端算法，生成前端唯一串
			var userAgent = navigator.userAgent;

			var getPluginsKey = function () {
				var pluginsList = navigator.plugins;
				var res = "";
				if (pluginsList.length > 0) {
					var list = [];
					for (var i = 0, maxi = pluginsList.length; i < maxi; i++) {
						var type = pluginsList[i].name;
						list.push(type);
					}
					res = list.toString();
				}
				return res;
			};
			var plugins = getPluginsKey();
			var screenResolution = screen.width + "x" + screen.height;
			var colorDepth = screen.colorDepth ? screen.colorDepth : "";
			var pixelDepthKey = screen.pixelDepth ? screen.pixelDepth : "";

			var getCanvasKey = function () {
				var result = ["canvas"];
				try {
					var canvas = document.createElement('canvas');
					if (!!(canvas.getContext && canvas.getContext('2d'))) {
						canvas.width = 200;
						canvas.height = 200;
						canvas.style.display = 'inline';
						var ctx = canvas.getContext('2d');
						ctx.rect(0, 0, 10, 10);
						ctx.rect(2, 2, 6, 6);
						result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'));
						ctx.textBaseline = 'alphabetic';
						ctx.fillStyle = '#f60';
						ctx.fillRect(125, 1, 62, 20);
						ctx.fillStyle = '#069';
						ctx.font = "14px 'Arial'";
						ctx.fillText('hello kugou', 2, 15);
						ctx.fillStyle = 'rgba(102, 204, 0, 0.2)';
						ctx.font = '18pt Arial';
						ctx.fillText('hello kugou', 4, 45);
						ctx.globalCompositeOperation = 'multiply';
						ctx.fillStyle = 'rgb(255,0,255)';
						ctx.beginPath();
						ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
						ctx.closePath();
						ctx.fill();
						ctx.fillStyle = 'rgb(0,255,255)';
						ctx.beginPath();
						ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
						ctx.closePath();
						ctx.fill();
						ctx.fillStyle = 'rgb(255,255,0)';
						ctx.beginPath();
						ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
						ctx.closePath();
						ctx.fill();
						ctx.fillStyle = 'rgb(255,0,255)';
						ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
						ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
						ctx.fill('evenodd');

						if (canvas.toDataURL) {
							result.push('canvas fp:' + canvas.toDataURL())
						}
					}
				} catch (error) { }

				return getBaseInfo.Md5(result.toString());
			};

			var canvasKey = getCanvasKey();

			mid = getBaseInfo.Md5(userAgent + plugins + screenResolution + colorDepth + pixelDepthKey + canvasKey);
		}
		return mid;
	},
}